import React from "react";
import Modal from "../Modal";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { Button } from "../../Button";
import { ReactComponent as Voltar } from "../../../assets/newImages/icons/angle-down.svg";
import Titulo from "../ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import { ContainerModalInfoMensagens } from "./styles";

interface ModalInfoMensagensProps {
  isOpen: boolean;
  setModal: (value: boolean) => void;
}

const ModalInfoMensagens: React.FC<ModalInfoMensagensProps> = ({
  isOpen,
  setModal,
}) => {
  const { theme } = useTheme();

  return (
    <Modal isOpen={isOpen} setModal={setModal} width="500px" maxWidth="90vw">
      <ContainerModalInfoMensagens theme={theme}>
        <div className="modal-header1">
          <Titulo titulo="Por que enviamos 3 mensagens diferentes?" subtitulo="" />
        </div>

        <div className="texto fonteTexto">
          <p>
            Enviamos{" "}
            <strong>3 mensagens diferentes de forma intercalada</strong> para
            tornar a <strong>comunicação mais segura.</strong>
          </p>
          <p>
            Como essa conexão com o WhatsApp utiliza uma integração não oficial,{" "}
            <strong>
              o envio repetitivo de mensagens iguais pode ser identificado como
              spam ou automação excessiva.
            </strong>{" "}
            Variando os textos entre os envios, reduzimos as chances de
            bloqueios e limitações temporárias, além de aumentar a taxa de
            entrega e deixar a abordagem mais humanizada para o cliente.
          </p>
        </div>

        <div className="botoes">
          <div className="cancelar fonteTexto" onClick={() => setModal(false)}>
            <Voltar /> Voltar
          </div>
          <Button
            title="Ok"
            padding="4.8rem"
            onClick={() => setModal(false)}
            className="fonteTexto"
          />
        </div>
      </ContainerModalInfoMensagens>
    </Modal>
  );
};

export default ModalInfoMensagens;
